import { render, staticRenderFns } from "./CopilotoConductores.vue?vue&type=template&id=4a82a55b&scoped=true&"
import script from "./CopilotoConductores.vue?vue&type=script&lang=ts&"
export * from "./CopilotoConductores.vue?vue&type=script&lang=ts&"
import style0 from "./CopilotoConductores.vue?vue&type=style&index=0&id=4a82a55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a82a55b",
  null
  
)

export default component.exports